import React, { FC } from 'react';
import { PageHeading, useMe } from 'src/common';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import LearnMoreLink from 'src/shared/LearnMoreLink';
import CategoriesList from './CategoriesList';
import styles from './index.module.scss';

export const CustomBidFields: FC = () => {
  const { t, i18n } = useTranslation();

  const { data: me } = useMe();
  const isAdmin = me?.isAdmin;

  return (
    <>
      <PageHeading
        title={t('Navigation.Settings.customBidFields')}
        icon={faPen}
        desc={
          <>
            <p>{t('CustomBidFields.customBidFieldsDesc')}</p>
            <LearnMoreLink
              className={styles.link}
              title={t('CustomBidFields.readMoreAboutBidFields')}
              href={`${import.meta.env.VITE_HELPDOCS_DOMAIN}${i18n.language}/article/uxidsao60c-anbudsfalt`}
            />
          </>
        }
      />
      <CategoriesList readOnly={!isAdmin} />
    </>
  );
};

export default CustomBidFields;
